import styled from 'styled-components';

export const Timer = styled.code`
`;
